import type { ValueAxisScales } from '@/shared/charts';

import { MEASURE_CHANNEL_TYPE, PATH_SERIES_ID } from './diagramIdentifiers';

/**
 * Value axis rules by axis group. A typed measure channel's group is its channel type (see
 * mapNumericSeries); speed has no type, so its group is its series id. The rules are carried over
 * from the previous iTrack client (ChartFactory.getLimitsDefault; speed from zero as in
 * XYSeriesCollectionWithRangeInfo). A group without an entry spans its raw data range.
 */
export const VALUE_AXIS_SCALES_BY_GROUP: ValueAxisScales = {
  [PATH_SERIES_ID.SPEED]: { forceMin: 0, marginRatio: 0 },
  [MEASURE_CHANNEL_TYPE.FUEL]: { forceMin: 0, minSpan: 100, lowerLimit: 0 },
  [MEASURE_CHANNEL_TYPE.FUEL_PERCENT]: { minSpan: 100, lowerLimit: 0, upperLimit: 100 },
  [MEASURE_CHANNEL_TYPE.RPM]: { minSpan: 100, lowerLimit: 0 },
  [MEASURE_CHANNEL_TYPE.HUMIDITY]: { minSpan: 10, lowerLimit: 0, upperLimit: 100 },
  [MEASURE_CHANNEL_TYPE.TEMPERATURE_C]: { minSpan: 10 },
  [MEASURE_CHANNEL_TYPE.TEMPERATURE_F]: { minSpan: 30 },
};
